var _style, _path, _g, _rect, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Step_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#55AD9C;}\r\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:7;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:7;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st3{fill:none;}\r\n\t.st4{fill:#FFFFFF;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M568.06,751.85C713.18,737.81,826.63,615.5,826.63,466.7c0-158.23-128.27-286.5-286.5-286.5 s-286.5,128.27-286.5,286.5c0,144.67,107.19,264.56,246.5,284"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M504.25,747.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M500.13,750.7c86.16-52.48,104.62-158.06,106.08-185.01c0.15-2.75,1.74-31.98,1.17-62.89 c-0.57-30.83-5.64-63.34-4.53-63.1c15.69,3.45,35.8,261.83-34.72,312.01"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M602.9,439.98c0,0,0-0.02-0.01-0.07c-0.14-0.06-0.28-0.11-0.43-0.17c0,0,0.05-0.14,0.16-0.42 c-12-1.77-23.43-5.33-33.6-9.22c-15.04,2.89-33.98,14.29-54.91,44.79c-50.68,73.87,24.07,2.51,24.07,2.51s0.76,6.01-5.06,11.68 c-5.79,5.64,13.29,9.34,69.94-49.12c-0.04-0.01-0.07-0.03-0.11-0.04C602.93,439.95,602.92,439.97,602.9,439.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M602.67,438.11c-0.14-1.5-0.26-3.88-0.14-7.05c-4.23-19.23-21.25-64.06-87.7-57.36 c-84.23,8.5,16.22,27.94,16.22,27.94s-16.27,4.15-6.61,9.46c4.27,2.35,4.53,0.53,20.19-5.72c2.05-0.82-10.27,9.98-7.61,11.03 c7.52,2.96,18.69,8.62,32,13.71C586.67,426.73,598.93,435.09,602.67,438.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M603.06,439.98c0.18,0.07,0.35,0.14,0.53,0.21c-0.1-0.15-0.2-0.3-0.29-0.45 C603.21,439.82,603.14,439.9,603.06,439.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M702.54,423.44c-33.7-22.32-57.15-21.73-72.84-14.13c-7.06,8.44-15.35,17.98-25.05,28.73 c4.54-0.72,16.13-0.58,32.55,13.49c47.8,13.28,58.56,1.8,52.17-0.41c-7.72-2.67-9.2-9.83-9.2-9.83S778.84,473.97,702.54,423.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M602.76,438.99c-0.05,0.13-0.1,0.25-0.14,0.35c0.06,0.01,0.12,0.02,0.19,0.03 C602.79,439.25,602.78,439.12,602.76,438.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M629.71,409.31c37.74-45.09,40.41-58.61,35.7-56.64c-7.11,2.97-10.33,4.77-10.33,4.77s79.47-88.87,7.15-33.24 c-16.38,12.6-34.9,39.2-35.86,52.75c-0.36,5.04-3.91-3.61-7.22,2.25c-13.27,23.45-16.22,41.7-16.61,51.85 c0.54,2.48,0.88,4.53,1.07,5.99C606.34,431.1,614.25,416.8,629.71,409.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M602.75,438.91c0,0.03,0.01,0.05,0.01,0.07c0-0.01,0.01-0.02,0.01-0.04 C602.77,438.94,602.76,438.93,602.75,438.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M603.01,438.39c-0.1-0.09-0.22-0.18-0.34-0.28c0.01,0.14,0.03,0.27,0.04,0.39c0.08-0.03,0.17-0.06,0.3-0.09 C603.01,438.4,603.01,438.39,603.01,438.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M602.81,439.36c0.04,0.28,0.07,0.46,0.08,0.55c0.02,0.01,0.04,0.01,0.05,0.02c0.09-0.1,0.18-0.2,0.28-0.31 c-0.05-0.08-0.1-0.16-0.15-0.23C602.98,439.38,602.9,439.37,602.81,439.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M603.75,438.21c-0.04-0.33-0.09-0.72-0.15-1.17c-0.24,0.51-0.43,0.96-0.59,1.34l0.01,0.01 C603.21,438.34,603.45,438.28,603.75,438.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M643.08,496.69c4.21,5.37,3.06-10.96,4.41-6.32c3.75,12.95,6.87,22.22,8.26,17.76 c2.47-7.91,0.4-12.4,0.4-12.4s58.6,88.37,21.08,7.06c-8.5-18.41-25.85-38.8-34.37-39.43c-3.17-0.23,2.11-4.62-1.68-8.23 c-1.36-1.29-2.68-2.48-3.98-3.59c-9.64-2.68-20.8-6.37-33.62-11.34C618.22,462.45,634.74,486.05,643.08,496.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M602.52,438.57c0.08,0.12,0.15,0.23,0.23,0.35c-0.01-0.13-0.03-0.27-0.05-0.42 C602.59,438.54,602.52,438.57,602.52,438.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M603.87,439.14c0,0-0.01-0.01-0.02-0.02c0,0.01,0,0.03,0,0.04C603.85,439.16,603.86,439.15,603.87,439.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M603.22,439.63c0.02,0.04,0.05,0.07,0.07,0.11c0.09-0.09,0.17-0.18,0.26-0.27c-0.05-0.01-0.11-0.02-0.16-0.02 C603.34,439.51,603.28,439.57,603.22,439.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M603.87,439.51c0,0-0.01-0.12-0.03-0.35c-0.1,0.1-0.19,0.2-0.29,0.3 C603.66,439.48,603.77,439.5,603.87,439.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M603.84,439.12c0-0.05-0.01-0.1-0.01-0.16c-0.02,0.03-0.05,0.05-0.07,0.08 C603.8,439.08,603.82,439.1,603.84,439.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M603.83,438.96c0.28-0.31,0.55-0.61,0.83-0.92c-0.34,0.05-0.65,0.11-0.91,0.17 C603.78,438.51,603.81,438.76,603.83,438.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M602.78,438.95c0.1,0.15,0.2,0.3,0.29,0.45c0.11,0.02,0.21,0.03,0.32,0.05c0.12-0.13,0.24-0.27,0.36-0.4 c-0.13-0.12-0.38-0.34-0.73-0.64c-0.01,0-0.01,0-0.02,0.01C602.92,438.61,602.84,438.79,602.78,438.95z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 325.38,
    y: 777.25,
    className: "st3",
    width: 467.52,
    height: 66.96
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 605.16,
    cy: 438.8,
    rx: 9.54,
    ry: 8.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.10ba21a02728494671f31acc40c07883.svg";
export { ForwardRef as ReactComponent };